// Real census from 2026-05-04. No "Other" bucket — every language with >0.5% share named.
// Source: agent census of ~/Cloudflare, ~/projects, ~/VSCode, ~/GitHub Repos, ~/Documents.

export interface RepoEntry {
  name: string;
  path: string;
  remote: string;
  primaryLanguage: string;
  languages: Record<string, number>; // share 0..1
  loc: number;
  lastCommit: string;
  topic: "infra-automation" | "data-pipeline" | "ml" | "web" | "tooling";
  deployable: boolean;
  pitch: string;
  notable: string[];
}

export const REPOS: RepoEntry[] = [
  { name: "Cloudflare", path: "~/Cloudflare", remote: "github.com/BrackenW3/Cloudflare", primaryLanguage: "TypeScript",
    languages: { TypeScript: 0.36, JSON: 0.21, YAML: 0.10, TOML: 0.08, Markdown: 0.06, JavaScript: 0.06, TSX: 0.05, Shell: 0.04, HTML: 0.03, SQL: 0.02 },
    loc: 253, lastCommit: "2026-05-01", topic: "infra-automation", deployable: true,
    pitch: "Monorepo of 21+ Cloudflare Workers and Pages apps powering willbracken.com, AI router, R2 explorer, and analytics dashboard.",
    notable: ["wrangler.toml × 21", "willbracken-landing", "r2-explorer", "analytics-dashboard"] },
  { name: "n8n Platform", path: "~/projects/n8n", remote: "github.com/BrackenW3/n8n", primaryLanguage: "JSON",
    languages: { JSON: 0.41, JavaScript: 0.15, Shell: 0.13, TOML: 0.08, Markdown: 0.07, YAML: 0.04, SQL: 0.04, HTML: 0.02, Cypher: 0.02, Python: 0.01, Go: 0.01 },
    loc: 190, lastCommit: "2026-05-01", topic: "data-pipeline", deployable: true,
    pitch: "41-workflow n8n automation platform on Railway, fronted by 14 Cloudflare Workers and a Neo4j knowledge graph.",
    notable: ["docker-compose.yml", "14 worker wrangler.toml", "go-tools/ binaries"] },
  { name: "litellm-stack", path: "~/litellm-stack", remote: "github.com/BrackenW3/litellm-stack", primaryLanguage: "Python",
    languages: { Markdown: 0.27, Text: 0.18, Python: 0.18, YAML: 0.18, Shell: 0.09, Env: 0.10 },
    loc: 11, lastCommit: "2026-05-01", topic: "ml", deployable: true,
    pitch: "Self-hosted LiteLLM proxy serving 99 models on :4000, with LangChain client and LoRA fine-tune scaffold.",
    notable: ["litellm/docker-compose.yml", "LangChain client", "LoRA scaffold"] },
  { name: "dispatch-portal", path: "~/dispatch-portal", remote: "github.com/BrackenW3/dispatch-portal", primaryLanguage: "TypeScript",
    languages: { TypeScript: 0.27, JSON: 0.16, Shell: 0.14, TSX: 0.05, Markdown: 0.05, JavaScript: 0.05, HTML: 0.03, CSS: 0.03, YAML: 0.03 },
    loc: 37, lastCommit: "2026-05-02", topic: "infra-automation", deployable: true,
    pitch: "Bun + MCP relay bridging MacBook to i9 desktop over a Cloudflare Tunnel with Access SSO.",
    notable: ["Bun MCP relay", "CF Tunnel", "Access SSO", "dispatch.willbracken.com"] },
  { name: "cloud-databases", path: "~/cloud-databases", remote: "github.com/BrackenW3/cloud-databases", primaryLanguage: "Markdown",
    languages: { Markdown: 0.26, YAML: 0.13, Python: 0.12, Cypher: 0.12, JavaScript: 0.07, SQL: 0.06, Shell: 0.06, JSON: 0.06, Text: 0.04 },
    loc: 68, lastCommit: "2026-05-01", topic: "data-pipeline", deployable: false,
    pitch: "Polyglot database playground: Neo4j Cypher, Postgres SQL, and seed/migration scripts for the personal data platform.",
    notable: ["Neo4j cypher × 8", "SQL schemas", "seed scripts"] },
  { name: "VSCode_Folders", path: "~/VSCode/VSCode_Folders", remote: "github.com/BrackenW3/VSCode_Folders", primaryLanguage: "JavaScript",
    languages: { Markdown: 0.27, JavaScript: 0.13, Python: 0.10, TypeScript: 0.07, JSON: 0.07, HTML: 0.06, Go: 0.04, PNG: 0.04, YAML: 0.04, TSX: 0.04, MDX: 0.03, Shell: 0.02, PowerShell: 0.01, CSS: 0.01, SVG: 0.01 },
    loc: 7423, lastCommit: "2026-04-15", topic: "tooling", deployable: true,
    pitch: "7,400+ file polyglot dev workspace housing 14 AI skills, MCP servers, Forge apps, Cloudflare workers, and 319 Go scripts.",
    notable: ["AI_Skills (14)", "mcp_servers/", "Cloudflare_Workers/", "Forge_Apps/", "Go-Scripts × 319"] },
  { name: "AI_Agent_Skills", path: "~/AI_Agent_Skills", remote: "github.com/BrackenW3/AI_Agent_Skills", primaryLanguage: "Python",
    languages: { Markdown: 0.49, XSD: 0.13, TTF: 0.12, Python: 0.10, Text: 0.07, CSV: 0.05, JSON: 0.03, PowerShell: 0.01 },
    loc: 923, lastCommit: "2026-04-26", topic: "tooling", deployable: true,
    pitch: "14 reusable Azure/Cloudflare agent skills packaged with Dockerfile, XSD schemas, and CSV libraries for Claude/Copilot.",
    notable: ["docker/Dockerfile", "CSV agent libs", "XSD schemas"] },
  { name: "Azure_GitHub", path: "~/GitHub Repos/Azure_GitHub", remote: "github.com/BrackenW3/Azure_GitHub", primaryLanguage: "Bicep",
    languages: { Bicep: 0.39, PowerShell: 0.22, Markdown: 0.22, Shell: 0.11, INI: 0.06 },
    loc: 18, lastCommit: "2026-04-12", topic: "infra-automation", deployable: false,
    pitch: "Bicep + PowerShell IaC modules deploying the personal Azure architecture (AOAI, KeyVault, n8n MSGraph app).",
    notable: ["7 Bicep modules", "deploy.ps1"] },
  { name: "Go-Scripts", path: "~/Documents/Go Scripts", remote: "github.com/BrackenW3/Go-Scripts", primaryLanguage: "Go",
    languages: { JSON: 0.43, Go: 0.29, Sum: 0.14, Mod: 0.14 },
    loc: 7, lastCommit: "2025-11-02", topic: "tooling", deployable: true,
    pitch: "Go utilities under go.mod for n8n tool integration and CLI helpers — runs as native binaries on macOS.",
    notable: ["go.mod", "n8n-fast-mac binary"] },
  { name: "VSCodespace", path: "~/VSCodespace", remote: "github.com/BrackenW3/VSCodespace", primaryLanguage: "Markdown",
    languages: { Markdown: 0.69, JSON: 0.09, PowerShell: 0.07, Shell: 0.04, YAML: 0.02, SQL: 0.01, JavaScript: 0.01, HTML: 0.01 },
    loc: 138, lastCommit: "2026-04-26", topic: "tooling", deployable: false,
    pitch: "Cross-machine VS Code config hub with 95+ runbook-style markdown docs and SSH/PowerShell automation.",
    notable: ["vscode-configs", "ssh_config"] },
  { name: "ms-teams-mockup", path: "~/VSCode/ms-teams-mockup", remote: "github.com/BrackenW3/VSCode_Folders", primaryLanguage: "HTML",
    languages: { HTML: 0.40, JavaScript: 0.30, JSON: 0.12, CSV: 0.08, Markdown: 0.06, Python: 0.04 },
    loc: 78, lastCommit: "2026-01-19", topic: "web", deployable: false,
    pitch: "Static HTML/JS Teams UI mockups paired with DuckDB-backed data demos.",
    notable: ["9 HTML mockups", "DuckDB demos"] },
  { name: "ClaudeAI", path: "~/Python Scripts/ClaudeAI", remote: "github.com/BrackenW3/ClaudeAI", primaryLanguage: "Python",
    languages: { Python: 0.40, JSON: 0.30, Markdown: 0.20, Env: 0.10 },
    loc: 10, lastCommit: "2025-11-30", topic: "ml", deployable: false,
    pitch: "Anthropic SDK experiment scripts — prompt caching tests, tool-use exploration.",
    notable: ["Anthropic SDK"] },
  { name: "Atlassian", path: "~/GitHub Repos/Atlassian", remote: "github.com/BrackenW3/Atlassian", primaryLanguage: "INI",
    languages: { INI: 0.57, Markdown: 0.14 },
    loc: 7, lastCommit: "2026-04-11", topic: "tooling", deployable: false,
    pitch: "Atlassian Forge configuration scratchpad for the family Jira/Confluence stack.",
    notable: [] },
  { name: "WSL_Docker", path: "~/GitHub Repos/WSL_Docker", remote: "github.com/BrackenW3/WSL_Docker", primaryLanguage: "Markdown",
    languages: { Markdown: 0.50, JSON: 0.50 },
    loc: 4, lastCommit: "2026-03-28", topic: "tooling", deployable: false,
    pitch: "WSL2 + Docker Desktop bring-up notes and config snippets for the i9 Windows box.",
    notable: [] },
  { name: "ClaudAI", path: "~/git/ClaudAI", remote: "github.com/BrackenW3/ClaudAI", primaryLanguage: "Markdown",
    languages: { Markdown: 0.97 },
    loc: 37, lastCommit: "2026-04-05", topic: "tooling", deployable: false,
    pitch: "Documentation-only repo capturing Claude Code workflow notes across machines.",
    notable: ["docs only"] },
];

// Portfolio-wide language breakdown — every language >0.5% named, no "Other" > 5%.
export const LANGUAGE_TOTALS: Array<{ name: string; share: number; color: string }> = [
  { name: "Markdown",   share: 0.305, color: "#94a3b8" },
  { name: "JavaScript", share: 0.118, color: "#f7df1e" },
  { name: "Python",     share: 0.104, color: "#3776ab" },
  { name: "TypeScript", share: 0.097, color: "#3178c6" },
  { name: "JSON",       share: 0.096, color: "#f59e0b" },
  { name: "HTML",       share: 0.053, color: "#e34f26" },
  { name: "Go",         share: 0.039, color: "#00add8" },
  { name: "YAML",       share: 0.038, color: "#cb171e" },
  { name: "TSX",        share: 0.037, color: "#5acaff" },
  { name: "MDX",        share: 0.024, color: "#fcb32c" },
  { name: "Shell",      share: 0.019, color: "#89e051" },
  { name: "XSD",        share: 0.015, color: "#0078d6" },
  { name: "PowerShell", share: 0.014, color: "#012456" },
  { name: "TOML",       share: 0.013, color: "#9c4221" },
  { name: "CSS",        share: 0.007, color: "#563d7c" },
  { name: "SVG",        share: 0.007, color: "#ff9a00" },
  { name: "CSV",        share: 0.007, color: "#a0aec0" },
  { name: "Cypher",     share: 0.005, color: "#018bff" },
  { name: "SQL",        share: 0.005, color: "#e38c00" },
  { name: "Bicep",      share: 0.001, color: "#0078d4" },
  { name: "Dockerfile", share: 0.001, color: "#384d54" },
];
